import { AuthRedirect } from './providers/AuthRedirect';
import { Identities } from './providers/Identities';
import { Localization } from './providers/Localization';
import { Referrer } from './providers/Referrer';
import { LocalSystemFilter } from './providers/LocalSystemFilter';
import { UserInfo } from './providers/UserInfo';
import { MfaFactors } from './providers/MfaFactors';

export function Store({ children }: { children: JSX.Element[] | JSX.Element }) {
	return (
		<Identities.Provider>
			<Referrer.Provider>
				<Localization.Provider>
					<AuthRedirect.Provider>
						<LocalSystemFilter.Provider>
							<UserInfo.Provider>
								<MfaFactors.Provider>
									{children}
								</MfaFactors.Provider>
							</UserInfo.Provider>
						</LocalSystemFilter.Provider>
					</AuthRedirect.Provider>
				</Localization.Provider>
			</Referrer.Provider>
		</Identities.Provider>
	);
}